import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function getDefaultAccessibility(projectCode, roleId, callback) {
	//now we will structure the data so that it looks like this --->> <moduleId>-<featureId>-<actionId>

	console.log('This is the param outside', projectCode, roleId);
	if (roleId !== '') {
		await firebaseRef
			.ref(
				'/kavtek_roles/' +
					projectCode +
					'/' +
					roleId +
					'/accessibilities'
			)
			.once('value', (snapshot) => {
				//initialization...
				var accessibilityParent = snapshot.val();
				if (accessibilityParent) {
					var accessibilityKeys = Object.keys(accessibilityParent);
					var checked = {};

					console.log('This is the param', projectCode, roleId);

					//lets loop through the database
					accessibilityKeys.forEach((moduleId) => {
						var featureObj = accessibilityParent[moduleId];

						var featureObjKeys = Object.keys(featureObj);

						featureObjKeys.forEach((featureId) => {
							var actionObj = featureObj[featureId];

							var actionKeys = Object.keys(actionObj);

							actionKeys.forEach((keys) => {
								var actionId = actionObj[keys];
								checked = {
									...checked,
									[`${moduleId}-${featureId}-${actionId}`]: true,
								};
							});
						});
					});

					callback(checked);
				} else {
					callback({});
				}
			});
	} else {
		callback({});
	}
}
